import { Link } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../styles/variables";
import type { LanguageProps } from "../typings";

const NotFound = ({ language }: LanguageProps) => (
  <StyledNotFound>
    <p className="code">404</p>
    <h1>{language === "Polish" ? "Nie znaleziono strony" : "Страница не найдена"}</h1>
    <p>
      {language === "Polish"
        ? "Sprawdź adres lub wróć na stronę główną."
        : "Проверьте адрес или вернитесь на главную страницу."}
    </p>
    <Link to="/">
      {language === "Polish" ? "Strona główna" : "На главную"}
    </Link>
  </StyledNotFound>
);

const StyledNotFound = styled.main`
  min-height: 70vh;
  padding: 10rem 1.5rem 5rem;
  text-align: center;
  .code { color: ${colors.primary}; font-size: 5rem; font-weight: 700; margin: 0; }
  h1 { margin: 0 0 1rem; }
  a { color: ${colors.primary}; display: inline-block; font-weight: 700; margin-top: 1.5rem; }
`;

export default NotFound;
